import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import Select from 'react-select-plus';
import { Icon } from '@mgc/react-components';
import PropTypes from 'prop-types';
import MapPropTypes from '../MapPropTypes';
import strings from '../../strings';
import './Selector.scss';
import * as format from '../../format';

export default class AlertToggle extends Component {
    static propTypes = {
        show: PropTypes.bool,
        bStyleClass: PropTypes.string,
        message: PropTypes.object,
        closeAlert: PropTypes.func.isRequired,
    };

    constructor() {
        super();
    }

    _isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    _handleAlertToggleClose(bool_val) {
        this.props.closeAlert(bool_val);
    }

    _buildErrorMessageBlock(message) {
        return (
            <ul>
                {message.map(function (item, index) {
                    return <li key={index}>{item.errorMessage != undefined ? item.errorMessage : item}</li>;
                })}
            </ul>
        );
    }

    _renderMessage(messageObj) {
        if (this._isJsonString(messageObj.message)) {
            {
                return this._buildErrorMessageBlock(
                    JSON.parse(messageObj.message)
                );
            }
        } else {
            return messageObj.message;
        }
    }

    _renderbStyleClass(messageObj) {
        return messageObj.errorType;
    }

    _renderAlertToggle() {
        if (this.props.showAlert == true) {
            return (
                <Alert
                    bsStyle={this._renderbStyleClass(this.props.message)}
                    onDismiss={() => this._handleAlertToggleClose(false)}
                >
                    <div className="">
                        <strong>
                            {this._renderMessage(this.props.message)}
                        </strong>
                    </div>
                </Alert>
            );
        }
    }
    render() {
        return <div>{this._renderAlertToggle()}</div>;
    }
}



// WEBPACK FOOTER //
// ./app/components/OrderForm/AlertToggle.jsx